import { render, staticRenderFns } from "./EducationTab.vue?vue&type=template&id=32620954"
import script from "./EducationTab.vue?vue&type=script&lang=js"
export * from "./EducationTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports